document.addEventListener('DOMContentLoaded',()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const loader=document.querySelector('.s24-loader');
  const hideLoader=()=>loader&&loader.classList.add('is-hidden');
  window.addEventListener('load',hideLoader,{once:true});setTimeout(hideLoader,2200);
  document.querySelectorAll('[data-reveal]').forEach((el)=>{const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.12});io.observe(el)});
  const progress=document.querySelector('.s24-progress span');
  const onScroll=()=>{const d=document.documentElement;const max=d.scrollHeight-d.clientHeight;if(progress)progress.style.width=(max?d.scrollTop/max*100:0)+'%';document.documentElement.style.setProperty('--scroll-y',window.scrollY+'px')};
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  if(!reduce) document.querySelectorAll('[data-tilt]').forEach(card=>{card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.style.transform=`perspective(1000px) rotateX(${y*-8}deg) rotateY(${x*10}deg) translateY(-6px)`});card.addEventListener('pointerleave',()=>card.style.transform='')});
  document.querySelectorAll('[data-countdown]').forEach(box=>{const target=new Date(box.dataset.countdown);const paint=()=>{let ms=Math.max(0,target-Date.now());const d=Math.floor(ms/86400000),h=Math.floor(ms/3600000)%24,m=Math.floor(ms/60000)%60,s=Math.floor(ms/1000)%60;box.querySelector('[data-days]').textContent=String(d);box.querySelector('[data-hours]').textContent=String(h).padStart(2,'0');box.querySelector('[data-minutes]').textContent=String(m).padStart(2,'0');box.querySelector('[data-seconds]').textContent=String(s).padStart(2,'0')};paint();setInterval(paint,1000)});
  document.querySelectorAll('[data-study-mode]').forEach(section=>{
    const tabs=section.querySelectorAll('[data-mode-tab]');
    const panels=section.querySelectorAll('[data-mode-panel]');
    tabs.forEach(tab=>tab.addEventListener('click',()=>{
      const id=tab.dataset.modeTab;
      tabs.forEach(t=>{const active=t===tab;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',active)});
      panels.forEach(panel=>panel.classList.toggle('is-active',panel.dataset.modePanel===id));
    }));
  });
  document.querySelectorAll('[data-world]').forEach(btn=>btn.addEventListener('click',()=>{const id=btn.dataset.world;document.querySelectorAll('[data-world-panel]').forEach(p=>p.classList.toggle('is-active',p.dataset.worldPanel===id));document.querySelectorAll('[data-world]').forEach(b=>b.classList.toggle('is-active',b===btn))}));
  document.querySelectorAll('[data-accordion]').forEach(btn=>btn.addEventListener('click',()=>{
    const item=btn.closest('.faq-wow__item, .product-v20__accordion, .product-v29__accordion');
    if(!item)return;
    if(item.classList.contains('faq-wow__item')){
      const panel=item.querySelector(':scope > div');
      if(!panel)return;
      const opening=!item.classList.contains('is-open');
      const start=panel.getBoundingClientRect().height;
      panel._s24FaqAnimation?.cancel();
      item.classList.toggle('is-open',opening);
      btn.setAttribute('aria-expanded',String(opening));
      panel.style.height='auto';
      const end=opening?panel.scrollHeight:0;
      panel.style.height=`${start}px`;
      item.classList.add('is-animating');
      panel._s24FaqAnimation=panel.animate(
        [{height:`${start}px`,opacity:opening?0:1},{height:`${end}px`,opacity:opening?1:0}],
        {duration:460,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'}
      );
      panel._s24FaqAnimation.onfinish=()=>{
        panel.style.height=opening?'auto':'0px';
        panel.style.opacity=opening?'1':'0';
        panel._s24FaqAnimation.cancel();
        panel._s24FaqAnimation=null;
        item.classList.remove('is-animating');
      };
      return;
    }
    const open=item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded',String(open));
  }));
});
// Product cinema interactions
window.addEventListener('DOMContentLoaded',()=>{
  const product=document.querySelector('[data-product-cinema]');
  if(!product)return;
  const dialog=product.querySelector('[data-preview-dialog]');
  product.querySelector('[data-preview-open]')?.addEventListener('click',()=>dialog?.showModal());
  product.querySelector('[data-preview-close]')?.addEventListener('click',()=>dialog?.close());
  dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});

  const select=product.querySelector('[data-variant-select]');
  const price=product.querySelector('[data-product-price]');
  const stickyPrice=product.querySelector('[data-sticky-price]');
  const lowestPrice=product.querySelector('[data-lowest-price]');
  select?.addEventListener('change',()=>{
    const selected=select.options[select.selectedIndex];
    const next=selected?.dataset.price;
    if(next){price.textContent=next;stickyPrice.textContent=next;}
    if(selected?.dataset.lowest&&lowestPrice)lowestPrice.textContent=selected.dataset.lowest;
  });

  const form=product.querySelector('[data-product-form]');
  const add=product.querySelector('[data-add-to-cart]');
  form?.addEventListener('submit',()=>{
    add?.classList.add('is-adding');
    const label=add?.querySelector('span');
    if(label)label.textContent='Dodaję do koszyka…';
    setTimeout(()=>{add?.classList.remove('is-adding');add?.classList.add('is-added');if(label)label.textContent='Dodano!';},650);
  });

  const sticky=product.querySelector('[data-sticky-buy]');
  const mainButton=product.querySelector('[data-add-to-cart]');
  if(sticky&&mainButton){
    const watcher=new IntersectionObserver(entries=>sticky.classList.toggle('is-visible',!entries[0].isIntersecting),{threshold:.05});
    watcher.observe(mainButton);
  }
  product.querySelector('[data-sticky-submit]')?.addEventListener('click',()=>{
    mainButton?.scrollIntoView({behavior:'smooth',block:'center'});
    setTimeout(()=>mainButton?.focus(),500);
  });
});

// V23 — automatyczne pobranie dominujących kolorów z okładki produktu
window.addEventListener('DOMContentLoaded',()=>{
  const product=document.querySelector('[data-product-cinema]');
  if(!product || product.dataset.productAccentMode!=='auto') return;
  const img=product.querySelector('.product-v20__cover');
  if(!img) return;

  const clamp=v=>Math.max(0,Math.min(255,Math.round(v)));
  const rgbToHex=(r,g,b)=>'#'+[r,g,b].map(v=>clamp(v).toString(16).padStart(2,'0')).join('');
  const luminance=(r,g,b)=>.2126*r+.7152*g+.0722*b;
  const saturation=(r,g,b)=>Math.max(r,g,b)-Math.min(r,g,b);

  const readColors=()=>{
    try{
      const canvas=document.createElement('canvas');
      const size=48;canvas.width=size;canvas.height=size;
      const ctx=canvas.getContext('2d',{willReadFrequently:true});
      ctx.drawImage(img,0,0,size,size);
      const data=ctx.getImageData(0,0,size,size).data;
      const pixels=[];
      for(let i=0;i<data.length;i+=16){
        const r=data[i],g=data[i+1],b=data[i+2],a=data[i+3];
        if(a<200)continue;
        const lum=luminance(r,g,b),sat=saturation(r,g,b);
        if(lum<18||lum>242||sat<18)continue;
        pixels.push({r,g,b,score:sat*(1-Math.abs(lum-130)/180)});
      }
      if(!pixels.length)return;
      pixels.sort((a,b)=>b.score-a.score);
      const primary=pixels[0];
      let secondary=pixels.find(p=>Math.abs(p.r-primary.r)+Math.abs(p.g-primary.g)+Math.abs(p.b-primary.b)>120) || pixels[Math.min(8,pixels.length-1)];
      const boost=c=>({r:clamp((c.r-128)*1.14+128),g:clamp((c.g-128)*1.14+128),b:clamp((c.b-128)*1.14+128)});
      const p=boost(primary),s=boost(secondary);
      product.style.setProperty('--product-accent',rgbToHex(p.r,p.g,p.b));
      product.style.setProperty('--product-accent-2',rgbToHex(s.r,s.g,s.b));
    }catch(err){/* ręczne kolory pozostają jako bezpieczny fallback */}
  };
  if(img.complete) readColors(); else img.addEventListener('load',readColors,{once:true});
});

// V24 — galeria okładki w filmowej scenie produktu
window.addEventListener('DOMContentLoaded',()=>{
  const gallery=document.querySelector('[data-product-gallery]');
  if(!gallery)return;
  const slides=[...gallery.querySelectorAll('[data-product-slide]')];
  const dotsWrap=gallery.closest('[data-product-stage]')?.querySelector('[data-gallery-dots]') || document.querySelector('[data-gallery-dots]');
  const prev=gallery.querySelector('[data-gallery-prev]');
  const next=gallery.querySelector('[data-gallery-next]');
  if(!slides.length)return;
  let current=0;
  const dots=slides.map((slide,i)=>{
    const dot=document.createElement('button');
    dot.type='button';dot.setAttribute('aria-label',`Pokaż zdjęcie ${i+1}`);
    const source=slide.querySelector('img');
    if(source){
      const thumb=document.createElement('img');
      thumb.src=source.currentSrc||source.src;
      thumb.alt='';thumb.loading='lazy';
      dot.appendChild(thumb);
    }
    dot.addEventListener('click',()=>show(i));dotsWrap?.appendChild(dot);return dot;
  });
  const show=(index)=>{
    current=(index+slides.length)%slides.length;
    slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===current));
    dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===current));
  };
  prev?.addEventListener('click',()=>show(current-1));
  next?.addEventListener('click',()=>show(current+1));
  if(slides.length<2){prev?.setAttribute('hidden','');next?.setAttribute('hidden','');if(dotsWrap)dotsWrap.hidden=true;}
  show(0);
});

// V28 — stabilna scena produktu bez przechylania i reakcji na kursor
window.addEventListener('DOMContentLoaded',()=>{
  const scene=document.querySelector('[data-product-stage]');
  if(!scene)return;
  scene.style.setProperty('--px','0px');
  scene.style.setProperty('--py','0px');
  scene.style.setProperty('--rx','0deg');
  scene.style.setProperty('--ry','0deg');

  const gallery=scene.querySelector('[data-product-gallery]');
  const next=gallery?.querySelector('[data-gallery-next]');
  const slides=gallery?[...gallery.querySelectorAll('[data-product-slide]')]:[];
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(next&&slides.length>1&&!reduce){
    let timer=setInterval(()=>next.click(),7000);
    const pause=()=>clearInterval(timer);
    const resume=()=>{clearInterval(timer);timer=setInterval(()=>next.click(),7000)};
    gallery.addEventListener('pointerenter',pause);
    gallery.addEventListener('pointerleave',resume);
    document.addEventListener('visibilitychange',()=>document.hidden?pause():resume());
  }
});

// V36: staggered cinematic description reveal
(() => {
  document.querySelectorAll('[data-story-content]').forEach((content) => {
    [...content.children].forEach((el, index) => el.style.setProperty('--v36-index', index));
  });
})();

// V38 — zdjęcia opisu jako osobne pełne bloki z animacją wejścia
window.addEventListener('DOMContentLoaded',()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-story-content]').forEach(content=>{
    const images=[...content.querySelectorAll('img')];
    images.forEach(img=>{
      delete img.dataset.v37Float;
      img.loading='lazy';
      img.decoding='async';
      const parent=img.parentElement;
      if(parent && (parent.tagName==='P' || parent.tagName==='FIGURE')) parent.classList.add('v38-media-block');
      if(reduce){ img.classList.add('is-in-view'); return; }
      const io=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            entry.target.classList.add('is-in-view');
            io.unobserve(entry.target);
          }
        });
      },{threshold:.14,rootMargin:'0px 0px -6% 0px'});
      io.observe(img);
    });
  });
});

// V41 — generowane gwiazdy, meteory i płynne kosmiczne przejścia
window.addEventListener('DOMContentLoaded',()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-v41-cosmos]').forEach((scene,sceneIndex)=>{
    if(scene.dataset.v41Ready)return;
    scene.dataset.v41Ready='1';
    const stars=scene.classList.contains('site-footer__cosmos')?70:110;
    for(let i=0;i<stars;i++){
      const star=document.createElement('i');
      star.className='v41-star';
      star.style.setProperty('--x',`${Math.random()*100}%`);
      star.style.setProperty('--y',`${Math.random()*100}%`);
      star.style.setProperty('--s',`${1+Math.random()*3.2}px`);
      star.style.setProperty('--o',`${.2+Math.random()*.75}`);
      star.style.setProperty('--d',`${2.6+Math.random()*5.4}s`);
      star.style.setProperty('--delay',`${-Math.random()*6}s`);
      scene.appendChild(star);
    }
    if(!reduce){
      const meteorCount=scene.classList.contains('site-footer__cosmos')?2:5;
      for(let i=0;i<meteorCount;i++){
        const meteor=document.createElement('i');
        meteor.className='v41-meteor';
        meteor.style.setProperty('--x',`${-10+Math.random()*85}%`);
        meteor.style.setProperty('--y',`${5+Math.random()*60}%`);
        meteor.style.setProperty('--d',`${6+Math.random()*6}s`);
        meteor.style.setProperty('--delay',`${i*1.7+Math.random()*4}s`);
        scene.appendChild(meteor);
      }
    }
  });
});

// V42 — pewne animacje wszystkich zdjęć w opisie produktu
window.addEventListener('DOMContentLoaded',()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-story-content]').forEach(content=>{
    content.querySelectorAll('img').forEach(img=>{
      img.classList.add('v42-story-image');
      const wrapper=(img.parentElement && /^(P|FIGURE|DIV)$/.test(img.parentElement.tagName)) ? img.parentElement : img;
      if(wrapper!==img) wrapper.classList.add('v42-media-reveal');
      if(reduce){ img.classList.add('is-in-view'); if(wrapper!==img) wrapper.classList.add('is-in-view'); return; }
      const target=wrapper;
      const io=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){
          target.classList.add('is-in-view');
          img.classList.add('is-in-view');
          io.unobserve(target);
        }
      }),{threshold:.12,rootMargin:'0px 0px -7% 0px'});
      io.observe(target);
    });
  });
});



// V47 — cienka, ciągła linia gradientowa wokół zdjęć w opisie
window.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-story-content] img').forEach(img=>{
    if(img.closest('.v45-orbit-wrap')) return;
    const frame=document.createElement('span');
    frame.className='v45-orbit-wrap';
    img.parentNode.insertBefore(frame,img);
    frame.appendChild(img);
  });
});

// V48 — żywy kosmos w nagłówku
window.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-s24-header-stars]').forEach(layer=>{
    if(layer.dataset.ready)return;
    layer.dataset.ready='1';
    const count=window.matchMedia('(max-width: 700px)').matches?44:92;
    for(let i=0;i<count;i++){
      const star=document.createElement('i');
      star.className='s24-header__star';
      star.style.setProperty('--x',`${Math.random()*100}%`);
      star.style.setProperty('--y',`${Math.random()*100}%`);
      star.style.setProperty('--s',`${.8+Math.random()*2.7}px`);
      star.style.setProperty('--o',`${.25+Math.random()*.75}`);
      star.style.setProperty('--d',`${2.2+Math.random()*5.5}s`);
      star.style.setProperty('--delay',`${-Math.random()*7}s`);
      layer.appendChild(star);
    }
  });
});




/* S24 Judge.me review entrance animations */
(function(){
  function initS24JudgeMe(){
    var shell=document.querySelector('[data-s24-judgeme]');
    if(!shell)return;
    var items=shell.querySelectorAll('.jdgm-rev:not([data-s24-ready])');
    if(!items.length)return;
    items.forEach(function(el,i){
      el.setAttribute('data-s24-ready','true');
      el.style.transitionDelay=Math.min(i*90,450)+'ms';
    });
    if(!('IntersectionObserver' in window)){
      items.forEach(function(el){el.classList.add('s24-review-visible')});return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('s24-review-visible');io.unobserve(entry.target)}})
    },{threshold:.12,rootMargin:'0px 0px -40px'});
    items.forEach(function(el){io.observe(el)});
  }
  document.addEventListener('DOMContentLoaded',initS24JudgeMe);
  document.addEventListener('shopify:section:load',initS24JudgeMe);
  var tries=0,t=setInterval(function(){initS24JudgeMe();if(++tries>20)clearInterval(t)},500);
})();


// V97 — opis produktu zawsze widoczny, bez zmiany oryginalnych ramek V90
(function(){
  function s24RevealDescription(){
    document.querySelectorAll('[data-product-story], [data-story-content]').forEach(function(el){
      el.classList.add('is-visible');
      el.style.opacity='1';
      el.style.visibility='visible';
      el.style.transform='none';
      el.style.minHeight='0';
      el.style.height='auto';
    });
    document.querySelectorAll('[data-story-content] img').forEach(function(img){
      img.classList.add('is-in-view');
      img.style.opacity='1';
      img.style.visibility='visible';
      img.style.transform='none';
      img.style.filter='none';
    });
  }
  document.addEventListener('DOMContentLoaded',s24RevealDescription);
  document.addEventListener('shopify:section:load',s24RevealDescription);
  setTimeout(s24RevealDescription,300);
  setTimeout(s24RevealDescription,1200);
})();

// V115 — usuwa puste bloki z edytora Shopify, które tworzą duże pionowe odstępy.
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-story-content]').forEach(function(content){
    Array.from(content.children).forEach(function(el){
      var text=(el.textContent||'').replace(/\u00a0/g,'').trim();
      var hasContent=Array.from(el.children).some(function(child){return !['BR','WBR'].includes(child.tagName)});
      if(!text&&!hasContent&&['P','DIV','SPAN'].includes(el.tagName))el.remove();
    });
  });
});
